import surfaceproduct1 from "../../../images/productsImages/surfaceImages/Residencial/Autocebantes/FE/FBSEF.jpg";
import surfaceproduct2 from "../../../images/productsImages/surfaceImages/Residencial/Autocebantes/FE/TURFBOSS.jpg";
import surfaceproduct3 from "../../../images/productsImages/surfaceImages/Residencial/Caracol/Speroni/YDCM.jpg";
import surfaceproduct4 from "../../../images/productsImages/surfaceImages/Residencial/Combustible/EGP10.png";
import surfaceproduct5 from "../../../images/productsImages/surfaceImages/Residencial/Combustible/EGP20.png";
import surfaceproduct6 from "../../../images/productsImages/surfaceImages/Residencial/Combustible/EGP30.jpg";
import surfaceproduct7 from "../../../images/productsImages/surfaceImages/Residencial/Jet/FE/SerieLJP.jpg";
import surfaceproduct8 from "../../../images/productsImages/surfaceImages/Residencial/Jet/FE/VERSAJETFVJ.jpg";
import surfaceproduct9 from "../../../images/productsImages/surfaceImages/Residencial/Jet/SPERONI/YDJSP.jpg";
import surfaceproduct10 from "../../../images/productsImages/surfaceImages/Residencial/Jet/SPERONI/YDJSPL.jpg";
import surfaceproduct11 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/FE/SerieBT4.jpg";
import surfaceproduct12 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/FE/SerieMH.png";
import surfaceproduct13 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/Little Giant/SerieLHLittleGiant.jpg";
import surfaceproduct14 from "../../../images/productsImages/surfaceImages/Residencial/Caracol/Speroni/ydch.jpg";
import surfaceproduct15 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/speroni/superficieCB.jpg";
import surfaceproduct16 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/speroni/HBI.jpg";
import surfaceproduct17 from "../../../images/productsImages/surfaceImages/Residencial/Periférica/LittleGiantSeriePG.png";
import surfaceproduct18 from "../../../images/productsImages/surfaceImages/Residencial/Periférica/persperoni.jpg";
import surfaceproduct19 from "../../../images/productsImages/surfaceImages/Residencial/Recirculadora/RecirculadorasAHW.jpg";
import surfaceproduct20 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/speroni/YDSM2.jpg";
import surfaceproduct21 from "../../../images/productsImages/surfaceImages/Residencial/Recirculadora/1040349.jpg";
import surfaceproduct22 from "../../../images/productsImages/surfaceImages/Residencial/Autocebantes/BGP/bgpauto.jpg";
import surfaceproduct23 from "../../../images/productsImages/surfaceImages/Residencial/Caracol/BGP/BGP-CHH.jpg";
import surfaceproduct24 from "../../../images/productsImages/surfaceImages/Residencial/Caracol/BGP/BGP-TIJ.jpg";
import surfaceproduct25 from "../../../images/productsImages/surfaceImages/Residencial/Jet/BGP/bgpjet.jpg";
import surfaceproduct26 from "../../../images/productsImages/surfaceImages/Residencial/Multietapa/BGP/BGP-CTI.jpg";
import surfaceproduct27 from "../../../images/productsImages/surfaceImages/Residencial/Periférica/bgpperi.jpg";
import pdf1 from "../../../pdf/surface/residential/FBSE.pdf";
import pdf2 from "../../../pdf/surface/residential/turfboss.pdf";
import pdf3 from "../../../pdf/surface/residential/YDJSP.pdf";
import pdf4 from "../../../pdf/surface/residential/BombaGasolinaEGP10.pdf";
import pdf5y6 from "../../../pdf/surface/residential/BombaGasolinaEGP20EGP30.pdf";
import pdf7 from "../../../pdf/surface/residential/LJP.pdf";
import pdf8 from "../../../pdf/surface/residential/FVJ.pdf";
import pdf9 from "../../../pdf/surface/residential/YDQ.pdf";
import pdf10 from "../../../pdf/surface/residential/YDJS-PL.pdf";
import pdf11 from "../../../pdf/surface/residential/BT4.pdf";
import pdf12 from "../../../pdf/surface/residential/SerieMH.pdf";
import pdf13 from "../../../pdf/surface/residential/LH.pdf";
import pdf14 from "../../../pdf/surface/residential/YDCM.pdf";
import pdf15 from "../../../pdf/surface/residential/CB-CBI.pdf";
import pdf16 from "../../../pdf/surface/residential/HBI-HBN.pdf";
import pdf17 from "../../../pdf/surface/residential/Serie-PG.pdf";
import pdf18 from "../../../pdf/surface/residential/YDCH.pdf";
import pdf19 from "../../../pdf/surface/residential/fichaAHW.pdf";
import pdf20 from "../../../pdf/surface/residential/YDSM2.pdf";
import pdf21 from "../../../pdf/surface/residential/HHHW.pdf";
import pdf22 from "../../../pdf/surface/residential/BGP-SWPSeries.pdf";
import pdf23 from "../../../pdf/surface/residential/BGP-CHHSeries.pdf";
import pdf24 from "../../../pdf/surface/residential/BGP-TIJSeries.pdf";
import pdf25 from "../../../pdf/surface/residential/BGP-CHJSeries.pdf";
import pdf26 from "../../../pdf/surface/residential/BGP-CTISeries.pdf";
import pdf27 from "../../../pdf/surface/residential/BGP-CHLSeries.pdf";
const fe = "Franklin Electric";

const surfaceResidentialProductList = [
  {
    _id: "surcatresauto001a",
    image: surfaceproduct1,
    title: "Bombas efluentes autocebantes serie FBSE",
    code: "",
    category: "Autocebantes",
    brand: fe,
    subcategory: fe,
    downLoad: pdf1,
  },
  {
    _id: "surcatresauto001b",
    image: surfaceproduct2,
    title: "Bombas aspersoras TURF BOSS",
    code: "",
    category: "Autocebantes",
    brand: fe,
    subcategory: fe,
    downLoad: pdf2,
  },
  {
    _id: "surcatresauto001c",
    image: surfaceproduct22,
    title: "Bombas autocebante serie SWP",
    code: "",
    category: "Autocebantes",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf22,
  },
  {
    _id: "surcatrescaracol001a",
    image: surfaceproduct14,
    title: "Bomba tipo caracol serie YDCH",
    code: "",
    category: "Caracol",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf18,
  },
  {
    _id: "surcatrescaracol001b",
    image: surfaceproduct3,
    title: "Bomba tipo caracol serie YDCM",
    code: "",
    category: "Caracol",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf14,
  },
  {
    _id: "surcatrescaracol001c",
    image: surfaceproduct23,
    title: "Bomba tipo caracol serie CHH",
    code: "",
    category: "Caracol",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf23,
  },
  {
    _id: "surcatrescaracol001d",
    image: surfaceproduct24,
    title: "Bomba tipo caracol serie TIJ",
    code: "",
    category: "Caracol",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf24,
  },
  {
    _id: "surcatrescom001a",
    image: surfaceproduct4,
    title: "Bomba de gasolina EGP10",
    code: "",
    category: "Combustible",
    brand: "Aquastrong",
    subcategory: "",
    downLoad: pdf4,
  },
  {
    _id: "surcatrescom001b",
    image: surfaceproduct5,
    title: "Bomba de gasolina EGP20",
    code: "",
    category: "Combustible",
    brand: "Aquastrong",
    subcategory: "",
    downLoad: pdf5y6,
  },
  {
    _id: "surcatrescom001c",
    image: surfaceproduct6,
    title: "Bomba de gasolina EGP30",
    code: "",
    category: "Combustible",
    brand: "Aquastrong",
    subcategory: "",
    downLoad: pdf5y6,
  },
  {
    _id: "surcatresjetfe001a",
    image: surfaceproduct7,
    title: "Bomba JET serie LJP",
    code: "",
    category: "Jet",
    brand: fe,
    subcategory: fe,
    downLoad: pdf7,
  },
  {
    _id: "surcatresjetfe001b",
    image: surfaceproduct8,
    title: "Bomba JET serie VERSAJET",
    code: "",
    category: "Jet",
    brand: fe,
    subcategory: fe,
    downLoad: pdf8,
  },
  {
    _id: "surcatresjetsperoni001a",
    image: surfaceproduct9,
    title: "Bomba JET serie YDJSP",
    code: "",
    category: "Jet",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf3,
  },
  {
    _id: "surcatresjetsperoni001b",
    image: surfaceproduct10,
    title: "Bomba JET serie YDJS-PL",
    code: "",
    category: "Jet",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf10,
  },
  {
    _id: "surcatresjetBGP001a",
    image: surfaceproduct25,
    title: "Bomba JET serie CHJ",
    code: "",
    category: "Jet",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf25,
  },
  {
    _id: "surcatresmulfe001b",
    image: surfaceproduct11,
    title: "Bombas multietapa serie BT4",
    code: "",
    category: "Multietapa",
    brand: fe,
    subcategory: fe,
    downLoad: pdf11,
  },
  {
    _id: "surcatresmulfe001c",
    image: surfaceproduct12,
    title: "Motor IEC serie MH",
    code: "",
    category: "Multietapa",
    brand: fe,
    subcategory: fe,
    downLoad: pdf12,
  },
  {
    _id: "surcatresmullg001b",
    image: surfaceproduct13,
    title: "Bomba horizontal serie LH",
    code: "",
    category: "Multietapa",
    brand: "Little Giant",
    subcategory: "Little Giant",
    downLoad: pdf13,
  },
  {
    _id: "surcatresmulsperonil001a",
    image: surfaceproduct15,
    title: "Electrobomba horizontal serie CB, CBI ",
    code: "",
    category: "Multietapa",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf15,
  },
  {
    _id: "surcatresmulsperoni001b",
    image: surfaceproduct16,
    title: "Electrobomba horizontal serie HBI, HBN",
    code: "",
    category: "Multietapa",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf16,
  },
  {
    _id: "surcatresmulsperoni001c",
    image: surfaceproduct20,
    title: "Bomba de doble impulsor serie YDSM2",
    code: "",
    category: "Multietapa",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf20,
  },
  {
    _id: "surcatresmulBGP001a",
    image: surfaceproduct26,
    title: "Bomba de doble impulsor serie CTI",
    code: "",
    category: "Multietapa",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf26,
  },
  {
    _id: "surcatresperlg001a",
    image: surfaceproduct17,
    title: "Bomba periférica Serie PG",
    code: "",
    category: "Periférica",
    brand: "Little Giant",
    subcategory: "Little Giant",
    downLoad: pdf17,
  },
  {
    _id: "surcatrespersperoni001a",
    image: surfaceproduct18,
    title: "Bomba periférica serie YDQ",
    code: "",
    category: "Periférica",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf9,
  },
  {
    _id: "surcatresperBGP001a",
    image: surfaceproduct27,
    title: "Bomba periférica serie CHL",
    code: "",
    category: "Periférica",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf27,
  },
  {
    _id: "surcatresrecirsperoni001a",
    image: surfaceproduct19,
    title: "Bomba recirculadora de agua caliente AHW",
    code: "",
    category: "Recirculadora",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf19,
  },
  {
    _id: "surcatresrecirsperoni001B",
    image: surfaceproduct21,
    title: "Bomba recirculadora de agua caliente seires HH y HW",
    code: "",
    category: "Recirculadora",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf21,
  },
];

export default surfaceResidentialProductList;
